import functions from "./functions";

let checkAllToggles;

function selectAllCheckbox() {

    checkAllToggles.forEach((input) => {
        checkAll.checked ? input.checked = true : input.checked = false;
    });
}

let checkAll;
let checkCount = 0;

function expandedOrderList() {
    const expandButtons = document.querySelectorAll('[data-expand-toggle]');

    expandButtons.forEach(e => {
        e.addEventListener('click', () => {
            e.previousElementSibling.classList.toggle('show');
            if (e.previousElementSibling.classList.contains('show')) {
                e.classList.add('active');
            } else {
                e.classList.remove('active');
            }
        });
    });
}

function handleLogout() {
    const logoutLinks = document.querySelectorAll('a[href*="customer-logout"]');

    logoutLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // Set cookie for redirect
            document.cookie = "user_just_logged_out=1; path=/; max-age=30";
        });
    });
}

function init() {

    if (functions.checkPage('my-account')) {
        checkAll = document.querySelector('[data-account-checkbox-all]');
        checkAllToggles = document.querySelectorAll('[data-account-checkbox-toggle]');

        if (checkAll && checkAllToggles) {
            checkAllToggles.forEach((input) => {
                input.checked ? checkCount++ : null;
                checkCount === checkAllToggles.length ? checkAll.checked = true : null;
            });
            checkAll.addEventListener('change', selectAllCheckbox);
        }

        expandedOrderList();
        handleLogout();
    }

    if (functions.checkPage('my-account')) {

        if (window.innerWidth <= functions.breakpoints.sm) {

            $('.my-account__nav').addClass('mobile');

            // Sprawdź czy użytkownik właśnie się zalogował
            const justLoggedIn = sessionStorage.getItem('just_logged_in');
            const isEditAccount = window.location.pathname.includes('edit-account');

            if (justLoggedIn && isEditAccount) {
                // Pierwszy raz po zalogowaniu na edit-account - pokaż menu
                $('.my-account__nav').addClass('visible');
                $('[data-navigation-output]').addClass('hidden');
                $('[data-navigation-backward]').addClass('hidden');
                sessionStorage.removeItem('just_logged_in');
            } else {
                // Normalne zachowanie - pokaż content
                $('.my-account__nav').removeClass('visible');
                $('[data-navigation-output]').removeClass('hidden');
                $('[data-navigation-backward]').removeClass('hidden');
            }

            $('[data-navigation-backward]').on('click', function () {
                $('[data-navigation-output]').addClass('hidden');
                $('.my-account__nav').addClass('visible');
                $(this).addClass('hidden');
            });

            $('.my-account__nav.mobile li a').on('click', function (e) {
                const clickedUrl = $(this).attr('href');
                const currentUrl = window.location.href;

                if (currentUrl === clickedUrl || currentUrl.indexOf(clickedUrl) === 0) {
                    e.preventDefault();
                    $('.my-account__nav').removeClass('visible');
                    $('[data-navigation-output]').removeClass('hidden');
                    $('[data-navigation-backward]').removeClass('hidden');
                } else {
                }
            });
        }
    }
}

export default {init};
